import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { PaymentRequest } from '../model/payment-request';
import { CommissionService } from './commission.service';

@Injectable()
export class CommissionStore {

  private _paymentRequest: BehaviorSubject<PaymentRequest> = new BehaviorSubject(new PaymentRequest());
  get paymentRequest(): Observable<PaymentRequest> { return this._paymentRequest.asObservable(); }

  private _errorResponse: BehaviorSubject<HttpErrorResponse> = new BehaviorSubject(null);
  get errorResponse(): Observable<HttpErrorResponse> { return this._errorResponse.asObservable(); }

  constructor(
    private commissionService: CommissionService,
    private router: Router,
  ) { }

  loadPaymentRequestDetails() {
    return this.commissionService.getPaymentRequestDetails()
      .catch(err => this.handleError(err))
      .pipe(map((res: PaymentRequest) => this._paymentRequest.next(res)));
  }

  private handleError(error: HttpErrorResponse): Observable<any> {
    this._errorResponse.next(error);
    this.router.navigate(['payment/error']);

    return Observable.empty();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/payment/service/commission.store.ts